import { NgModule } from '@angular/core';

import { EffectsModule } from "@ngrx/effects";
import { UiHelperModule } from "../../ui-helper";

import { SponsorEffects } from './sponsor.effects';
import { SponsorActions } from './sponsor.actions'
import {
	SponsorResolver,
	SponsorCodeListResolver,
	CodeEditResolver,
	CodeCreateResolver,
	CodeUsageListResolver,
	CodeUsageCreateResolver,
	CodeUsageEditResolver,
	CodeUsageEventListResolver,
	SeatingplanResolver } from './sponsor.resolver'

@NgModule({
	imports: [
		UiHelperModule,
		EffectsModule.forFeature([SponsorEffects])
	],
	providers: [
		SponsorResolver,
		SponsorCodeListResolver,
		CodeEditResolver,
		CodeCreateResolver,
		CodeUsageListResolver,
		CodeUsageCreateResolver,
		CodeUsageEditResolver,
		CodeUsageEventListResolver,
		SeatingplanResolver,
		SponsorActions
	]
})
export class SponsorModule {
	constructor() {

	}
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/sponsor.module.ts